export default __webpack_public_path__ + "static/media/greenpizza.dd18704c.jpg";